<template>
  <div class="logview">
    <DetailView :log="log"></DetailView>
  </div>
</template>

<script>
import firebase from 'firebase'
import axios from 'axios'
const apiUrl = 'https://logcrow.appspot.com/'
// const apiUrl = 'http://192.168.212.101:9999/'
// const apiUrl = 'http://localhost:9999/'
import DetailView from './DetailView.vue'
export default {
  name: 'LogView',
  components: {
    DetailView
  },
  data() {
    return {
      log: null,
    }
  },
  methods: {
    makeToast(variant = null, message) {
      this.$root.$bvToast.toast(message, {
        title: `${variant || 'message'}`,
        variant: variant,
        solid: true
      })
    },
    setMeta(log) {
      document.title = "LogCrow - " + log.log.substr(0, 50)
      document.querySelector("meta[property='og:title']").setAttribute('content', log.log.substr(0,50))
      document.querySelector("meta[name='description']").setAttribute('content', log.log.substr(0,120))
      document.querySelector("meta[property='og:description']").setAttribute('content', log.log.substr(0,120))
      document.querySelector("meta[property='og:url']").setAttribute('content', 'https://logcrow.firebaseapp.com/log/' + this.$route.params.logid)
    },
    getLog() {
      let currentUser = firebase.auth().currentUser
      if (currentUser) {
        currentUser.getIdToken(true).then(async (idToken) => {
          let res = await axios.get(apiUrl + 'log_withid', {
            headers: {
              'Authorization': `Bearer ${idToken}`,
              'Content-Type': 'application/json'
            },
            params: {
              logID: this.$route.params.logid
            }
          })
          this.log = res.data
          this.setMeta(this.log)
        }).catch(() => {
          this.makeToast('warning', "Failed to get log data...")
        })
      } else {
        // 未ログイン状態での検索処理
        let search = async () => {
          let res = await axios.get(apiUrl + 'log_withid', {
            params: {
              logID: this.$route.params.logid
            }
          })
          if (res.data) {
            this.log = res.data
            this.setMeta(this.log)
          } else {
            this.makeToast('warning', "No log data...")
          }
        }
        search()
      }
    },
  },
  mounted: function() {
    this.getLog()
  }
}
</script>

<style>
.md-body {
  border-color: #e9ecef;
  border-width: 1px;
}
</style>
